<template>
<div>
  <strong>{{category}}</strong>
  <v-chip-group multiple column :value="value" @change="listChange">
    <v-chip v-for="s in services" :key="s.service_id"
      :color="value.includes(s.service_id) ? 'primary' : 'grey lighten-3'"
      :value="s.service_id"
      small
      :style="styleFor(s.service_id)"
    >
      <v-icon small left v-if="value.includes(s.service_id)">
        mdi-check
      </v-icon>
      {{ s.service }}
    </v-chip>
  </v-chip-group>
</div>
</template>

<script>
export default {  
  props: ['category', 'services', 'value'],

  methods: {
    listChange(newVal) {
      this.$emit('input', newVal)
    },
    
    styleFor(id) {
      return !this.value.includes(id) ? 'border: 1px solid #C0C0C0 !important;' : ''
    },
  },
}
</script>